"use client"

import styled from "@emotion/styled"
import { getUmbracoMediaUrl } from "@eurodrive/utils/getUmbracoMediaUrl"
import { Typography } from "@mui/material"
import { AdvancedMarker } from "@vis.gl/react-google-maps"
import { BranchDto } from "api"
import Image from "next/image"
import Link from "next/link"

const InnerCard = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
`

const ImageContainer = styled.div`
  width: 100%;
  height: 104px;
  position: relative;
`

const ContentBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  padding: 0px 12px 16px 12px;
`

const DetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const DetailsRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const TimeColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  border-bottom: 1px solid #000;
  display: flex;
  gap: 8px;
  align-items: center;
`

const MarkerTooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
  min-width: 180px;
  min-height: 300px;
  z-index: 1000000;

  &:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }
`

function getTime(time: string) {
  const [hours, minutes] = time.split(":")
  const formattedTime = `${hours}.${minutes}` // "20.00"

  return formattedTime
}

const CustomMarker = ({
  branch,
  isSelected,
  onClick,
  branchImage,
}: {
  branch: BranchDto
  isSelected: boolean
  onClick: () => void
  branchImage?: string
}) => {
  return (
    <AdvancedMarker
      position={{ lat: branch.latitude, lng: branch.longitude }}
      onClick={onClick}
      zIndex={isSelected ? 1000 : 1}
    >
      <div style={{ position: "relative" }}>
        <Image src={"/icons/location_on.svg"} alt="" width={48} height={48} />
        {isSelected && (
          <MarkerTooltip>
            <InnerCard>
              <ImageContainer>
                <Image
                  fill
                  src={getUmbracoMediaUrl(branchImage || "")}
                  alt={branch.branchName || ""}
                />
              </ImageContainer>
              <ContentBox>
                <Typography variant="body2">{branch.branchName}</Typography>
                <DetailsBox>
                  <DetailsRow>
                    <Image
                      src="/icons/map.svg"
                      alt="מיקום"
                      width={18}
                      height={18}
                    />
                    <Typography variant="body2">
                      {branch.street} {branch.houseNumber}, {branch.city}
                    </Typography>
                  </DetailsRow>
                  <DetailsRow>
                    <Image
                      src="/icons/clock.svg"
                      alt="שעות פעילות"
                      width={18}
                      height={18}
                    />
                    <TimeColumn>
                      <Typography variant="body2">
                        א׳ - ה׳: {getTime(branch.regularDayOpeningHours)} -{" "}
                        {getTime(branch.regularDayClosingHours)}
                      </Typography>
                      <Typography variant="body2">
                        ו׳: {getTime(branch.holidayDayOpeningHours)} -{" "}
                        {getTime(branch.holidayDayClosingHours)}
                      </Typography>
                    </TimeColumn>
                  </DetailsRow>
                  <DetailsRow>
                    <Image
                      src="/icons/email.svg"
                      alt="אימייל"
                      width={18}
                      height={18}
                    />
                    <Typography variant="body2">
                      {branch.emailAddress}
                    </Typography>
                  </DetailsRow>
                  <DetailsRow>
                    <Image
                      src="/icons/phone.svg"
                      alt="טלפון"
                      width={18}
                      height={18}
                    />
                    <Typography variant="body2">
                      {branch.phoneNumbers[0]}
                    </Typography>
                  </DetailsRow>
                </DetailsBox>
              </ContentBox>
            </InnerCard>
          </MarkerTooltip>
        )}
      </div>
    </AdvancedMarker>
  )
}

export default CustomMarker
